import { buildWorkflowDisplayDraft } from "../constants/workflowDisplayDefaults";

export const WORKFLOW_GROUPS = {
  SO: "SO",
  PO: "PO",
  GLOBAL: "GLOBAL",
};

export const normalizeWorkflowDisplaySettings = (rawSettings) =>
  buildWorkflowDisplayDraft(rawSettings || {});

export const resolveWorkflowDisplayEntry = ({
  workflowDisplaySettings,
  group,
  statusKey,
}) => {
  const normalized = normalizeWorkflowDisplaySettings(workflowDisplaySettings);
  const key = String(statusKey || "").trim();

  if (!key) {
    return { displayLabel: "", tooltip: "" };
  }

  const entry = normalized?.[group]?.[key];
  if (entry && typeof entry === "object") {
    return {
      displayLabel: entry.displayLabel || key,
      tooltip: entry.tooltip || "",
    };
  }

  return {
    displayLabel: key,
    tooltip: "",
  };
};

export const getWorkflowDisplayLabel = ({
  workflowDisplaySettings,
  group,
  statusKey,
}) =>
  resolveWorkflowDisplayEntry({
    workflowDisplaySettings,
    group,
    statusKey,
  }).displayLabel;

export const getWorkflowDisplayTooltip = ({
  workflowDisplaySettings,
  group,
  statusKey,
}) =>
  resolveWorkflowDisplayEntry({
    workflowDisplaySettings,
    group,
    statusKey,
  }).tooltip;
